/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/app/modules/Auth/pages/AuthPage`, `src/app/BasePage`).
 */

import {FC} from 'react'
import {Routes, Route, BrowserRouter, Navigate} from 'react-router-dom'
import {PrivateRoutes} from './PrivateRoutes'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {Logout, AuthPage, useAuth} from '../modules/auth'
import {App} from '../App'
import { PeopleLogin } from '../modules/auth/components/PeopleLogin'
import { LayoutProvider } from '../../_metronic/layout/core'
import LogInSplashScreen from '../../_metronic/layout/core/LogInSplashScreen';
import StoreToken from '../pages/receive-token/StoreToken'

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const {PUBLIC_URL} = process.env

const AppRoutes: FC = () => {
  const {currentUser} = useAuth()
  return (
    <BrowserRouter basename={PUBLIC_URL}>
      <Routes>
        <Route element={<App />}>
          <Route path='error/*' element={<ErrorsPage />} />
          <Route path='logout' element={<Logout />} />
          <Route path='store-token' element={<StoreToken />} />
          {currentUser ? (
            <>
            <Route path='/loading' element={<LogInSplashScreen />} />
              <Route path='/*' element={<PrivateRoutes />} />
              {/* commenting for future use  */}
              {/* <Route index element={<Navigate to='/dashboard' />} /> */}
            </>
          ) : (
            <>
              <Route path='auth/*' element={<AuthPage />} />
              <Route path="*" element={<Navigate to={'/auth/login'} />} />

              {/* <Route path="*" element={<Navigate to={'/auth/people/login'} />} /> */}
              {/* <Route path='*' element={<Navigate to='/auth/customer-register' />} /> */}
            </>
          )}
        </Route>
      </Routes>
    </BrowserRouter>
  )
}

export {AppRoutes}
